module.exports = __webpack_public_path__ + "4e890afd5056bde2bce56a23277c321b.svg";